import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  FormHelperText,
} from "@mui/material";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import { useMutation } from "@apollo/client";
//Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import { UPDATE_UNIT } from "../../Schema/Unit";



export default function UpdateUnit({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  // const { language } = useContext(AuthContext);
  // const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [role, setRole] = useState("ប្រធានក្រុមប្រឹក្សា");
  const [userValue, setUserValue] = useState({ title: "", id: "" });

  // ========================= upload Image =========================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);


  // ======================= Progress ==============================
  const [statusProgress, setStatusProgress] = useState(false);
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 10
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  // ===================== End progress =============================

  const [updateUnit] = useMutation(UPDATE_UNIT, {
    onCompleted: ({ updateUnit }) => {
      setLoading(false);
      // console.log("updateUnit::", updateUnit);
      if (updateUnit?.status) {
        setAlert(true, "success", updateUnit?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        // console.log("updateUnit::", updateUnit);
        setAlert(true, "error", updateUnit?.message);
      }
    },
    onError: (error) => {
      // console.log("updateUnit::", updateUnit);
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    unitKhName: Yup.string().required("require!"),
    unitEnName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
        remark: "",
        unitEnName: "",
        unitKhName: ""
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      console.log("values:::", values);
      setLoading(true);
      updateUnit({
        variables: {
          id: editData?._id,
          input: {
            ...values
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;


  useEffect(() => {
    if (editData) {
      setFieldValue("unitKhName", editData?.unitKhName);
      setFieldValue("unitEnName", editData?.unitEnName);
      setFieldValue("remark", editData?.remark);
      
    }
  }, [editData]);

  

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              កែប្រែខ្នាត
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={6}>
                <Typography className="field-title">ខ្នាតជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ខ្នាតជាខ្មែរ"
                  {...getFieldProps("unitKhName")}
                  error={Boolean(touched.unitKhName && errors.unitKhName)}
                  helperText={touched.unitKhName && errors.unitKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">ខ្នាតជាអង់គ្លេស</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ខ្នាតជាអង់គ្លេស"
                  {...getFieldProps("unitEnName")}
                  error={Boolean(touched.unitEnName && errors.unitEnName)}
                  helperText={touched.unitEnName && errors.unitEnName}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={statusProgress && progress < 100 ? true : false}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
